import { APP_INITIALIZER, ModuleWithProviders, NgModule } from "@angular/core";
import { Actions, EffectsModule } from "@ngrx/effects";
import { PlatformService } from "@obg/ngx.global.evo";
import { isFunction, noop } from "lodash-es";

import { _NGRX_UTILS_CONFIG, NGRX_UTILS_CONFIG } from "./const";
import { ActionsExtended } from "./extensions/actions-extended";
import { NgrxUtilsConfig } from "./model";
import { StateCacheEffect } from "./state-cache/state-cache.effect";
import { StateTransferEffect } from "./state-transfer/state-transfer.effect";
import { StateTransferService } from "./state-transfer/state-transfer.service";

@NgModule({
	imports: [EffectsModule.forFeature([StateTransferEffect, StateCacheEffect])],
})
export class NgrxUtilsModule {
	static forRoot(): ModuleWithProviders<NgrxUtilsModule>;

	static forRoot<T>(config: NgrxUtilsConfig<T> | (() => NgrxUtilsConfig<T>)): ModuleWithProviders<NgrxUtilsModule>;

	static forRoot<T>(config?: NgrxUtilsConfig<T> | (() => NgrxUtilsConfig<T>)): ModuleWithProviders<NgrxUtilsModule> {
		return {
			ngModule: NgrxUtilsModule,
			providers: [
				{ provide: NGRX_UTILS_CONFIG, useFactory: _ngrxUtilsConfigFactory, deps: [_NGRX_UTILS_CONFIG] },
				{ provide: _NGRX_UTILS_CONFIG, useValue: config },
				{ provide: Actions, useClass: ActionsExtended },
				{
					provide: APP_INITIALIZER,
					multi: true,
					useFactory: _initializeStateTransfer,
					deps: [StateTransferService, PlatformService],
				},
			],
		};
	}
}

/** @internal */
export function _initializeStateTransfer(
	stateTransferService: StateTransferService,
	platformService: PlatformService
): () => void {
	if (platformService.isServer) {
		return stateTransferService.saveState.bind(stateTransferService);
	}

	return noop;
}

/**
 * @internal
 */
export function _ngrxUtilsConfigFactory<T>(config?: NgrxUtilsConfig<T> | (() => NgrxUtilsConfig<T>)) {
	return isFunction(config) ? config() : config;
}
